import React, { useState } from "react";

function Technology() {
  // State to manage the active tab
  const [activeTab, setActiveTab] = useState("data-warehousing");

  // Handler to set the active tab
  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  return (
    <div class="container d-flex justify-content-center mt-5">
      <div class="col-xl-10 col-lg-12 col-md-12 col-sm-12 col-12">
        <div class="tab-vertical">
          <ul class="nav nav-tabs" role="tablist">
            <li class="nav-item">
              <button
                class={`nav-link ${
                  activeTab === "data-warehousing" ? "active" : ""
                }`}
                onClick={() => handleTabClick("data-warehousing")}
              >
                Data Warehousing
              </button>
            </li>
            <li class="nav-item">
              <button
                class={`nav-link ${
                  activeTab === "quality-assurance" ? "active" : ""
                }`}
                onClick={() => handleTabClick("quality-assurance")}
              >
                Quality Assurance
              </button>
            </li>
            <li class="nav-item">
              <button
                class={`nav-link ${activeTab === "database" ? "active" : ""}`}
                onClick={() => handleTabClick("database")}
              >
                Database
              </button>
            </li>
            <li class="nav-item">
              <button
                class={`nav-link ${activeTab === "programming" ? "active" : ""}`}
                onClick={() => handleTabClick("programming")}
              >
                Programming
              </button>
            </li>
            <li class="nav-item">
              <button
                class={`nav-link ${activeTab === "business-analysis" ? "active" : ""}`}
                onClick={() => handleTabClick("business-analysis")}
              >
                Business Analysis
              </button>
            </li>
            <li class="nav-item">
              <button
                class={`nav-link ${activeTab === "project-management" ? "active" : ""}`}
                onClick={() => handleTabClick("project-management")}
              >
                Project Management
              </button>
            </li>
            <li class="nav-item">
              <button
                class={`nav-link ${activeTab === "erp" ? "active" : ""}`}
                onClick={() => handleTabClick("erp")}
              >
                ERP
              </button>
            </li>
            <li class="nav-item">
              <button
                class={`nav-link ${activeTab === "sdlc-methodologies" ? "active" : ""}`}
                onClick={() => handleTabClick("sdlc-methodologies")}
              >
                SDLC Methodologies
              </button>
            </li>
          </ul>
          <div class="tab-content">
            <div
              class={`tab-pane fade ${
                activeTab === "data-warehousing" ? "show active" : ""
              }`}
            >
              <p>
                All organizations regard their stores of data as one of their
                most valuable asset. There is an immense need to manage and
                maintain the data as it is used to help achieve business goals
                and CRM.
                <br />
                The key data is used to make informed decisions and increase
                operational efficiencies of the organization. The changes in
                data need to be delivered to people and processes need to act
                upon them, this is possible only if right data ware housing
                infrastructure is in place.
                <br />
                Other tools extensively used for data warehousing projects by
                our consultants are Informatica, Data Stage, Hyperion, Cognos
                and Crystal Reports.
              </p>
            </div>
            <div
              class={`tab-pane fade ${
                activeTab === "quality-assurance" ? "show active" : ""
              }`}
            >
              <p>
                Quality assurance, or QA for short, refers to planned and
                systematic production processes that provide confidence in a
                product's suitability for its intended purpose. It is a set of
                activities intended to ensure that products (goods and/or
                services) satisfy customer requirements in a systematic,
                reliable fashion. QA cannot absolutely guarantee the production
                of quality products, unfortunately, but makes this more likely.
              </p>
            </div>
            <div
              class={`tab-pane fade ${
                activeTab === "database" ? "show active" : ""
              }`}
            >
              <p>
                To manage and store large volume of information a database may
                be beneficial for your business. It helps to store new
                information, to run search facilities, to generate regular
                reports based on a real-time selection of data. <b>revtech</b> is
                experienced in developing a wide variety of databases. <b>revtech</b>
                can deliver custom designed database applications using a wide
                variety of tools, techniques and programming languages including
                MS Access, ADP, VB, SQL Server, MySQL, Oracle and Ingres and can
                advise you on the most appropriate techniques to suit your
                database needs.
              </p>
            </div>
            <div
              class={`tab-pane fade ${
                activeTab === "programming" ? "show active" : ""
              }`}
            >
              <p>
              A programming language is a machine-readable artificial language designed to express computations that can be performed by a computer. Programming languages can be used to create programs that specify the behavior of a machine, to express algorithms precisely, or as a mode of human communication. Well known example of programming languages are DOS, MS .Net, Java, Java Script, Jscript, JCL, REXX, C, C#, C++, COBOL, Python, VB, VC++, PHP, Perl, Ruby on Rails, Flex, etc.
              </p>
            </div>
            <div
              class={`tab-pane fade ${
                activeTab === "business-analysis" ? "show active" : ""
              }`}
            >
              <p>
                Business analysis is the set of tasks, knowledge, and techniques required to identify business needs and determine solutions to business problems. Solutions often include a systems development component, but may also consist of process improvement or organizational change. The person who carries out this task is called a business analyst.
              </p>
            </div>
            <div
              class={`tab-pane fade ${
                activeTab === "project-management" ? "show active" : ""
              }`}
            >
              <p>
              Project management is the discipline of planning, organizing and managing resources to bring about the successful completion of specific project goals and objectives. There are several approaches that can be taken to managing project activities including agile, interactive, incremental, and phased approaches.
              </p>
            </div>
            <div
              class={`tab-pane fade ${
                activeTab === "erp" ? "show active" : ""
              }`}
            >
              <p>
                Enterprise resource planning (ERP) is a company-wide computer software system used to manage and coordinate all the resources, information, and functions of a business from shared data stores. An ERP system has service oriented architecture with modular hardware and software units or "services" that communicate on a LAN. The modular design allows a business to add or reconfigure modules (perhaps from different vendors) while preserving data integrity in one shared database that may be centralized or distributed.
              </p>
            </div>
            <div
              class={`tab-pane fade ${
                activeTab === "sdlc-methodologies" ? "show active" : ""
              }`}
            >
              <p>
              A software development process is a structure imposed on the development of a software product. Synonyms include software life cycle and software process. There are several models for such processes, each describing approaches to a variety of tasks or activities that take place during the process.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Technology;
